import useAuthStore from '@/stores/authStore';
import type { NavigationGuardWithThis } from 'vue-router';

export default <NavigationGuardWithThis<undefined>>((_to, _from, next) => {
  const authStore = useAuthStore();
  if (authStore.isApproved) {
    return next({
      name: 'home',
    });
  }
  return next();
});
